export default __webpack_public_path__ + "static/media/pdf-logo.87f34540.png";